import React from 'react';
export const ThemeContext = React.createContext(
   {
      darkMode: (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches),
      toggleTheme: () => { }
   }
);